module.exports = __webpack_public_path__ + "static/media/pic-seller.3a1eca60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic-seller.png
// module id = 180
// module chunks = 0